export const breadcrumbs = [
  {
    text: "Главная",
    disabled: false,
    href: "/",
  },
  {
    text: "Мониторинг",
    disabled: true,
    href: "breadcrumbs_link_1",
  },
];
